const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getWorkOrders(orgId, filters = {}) {
  const params = new URLSearchParams();
  if (filters.siteId) params.append('siteId', filters.siteId);
  if (filters.assetId) params.append('assetId', filters.assetId);
  if (filters.status) params.append('status', filters.status);
  if (filters.priority) params.append('priority', filters.priority);
  if (filters.type) params.append('type', filters.type);
  if (filters.limit) params.append('limit', filters.limit.toString());
  if (filters.offset) params.append('offset', filters.offset.toString());
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/work-orders${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch work orders');
  }
  
  return response.json();
}

export async function getWorkOrder(orgId, workOrderId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/work-orders/${workOrderId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      return null;
    }
    throw new Error('Failed to fetch work order');
  }
  
  const data = await response.json();
  return data.workOrder;
}
